import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { ICouponServiceTypeResponse, ICouponServiceTypeResponseData } from "@/api_framework/api_modals/coupon";

AxiosCurlirize(axios, () => {});

export interface ICouponServiceCartTypeResponse {
  status: boolean;
  message: string;
  data: ICouponServiceCartType[];
}
export interface ICouponServiceCartType {
  id: number;
  label: string;
  value: string;
}

export const useCouponCARTTypeListAPI = () => {
  const [cartType, setCartType] = useState<ICouponServiceCartType[]>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(COUPON_SERVICE_APIS?.CART_TYPE?.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ICouponServiceCartTypeResponse>) => {
          if (res.data.status) {
            setCartType(res.data.data);
            //
          } else {
            setCartType([]);
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          if (e.code === "ERR_BAD_REQUEST") {
            setCartType([]);
            //   toast.error("Error while fetching List details");
          }
          if (e.status === 400) {
            setCartType([]);
            //   toast("Product records not found");
          }

          if (e.response.status === 500) {
            setCartType([]);
            toast.error("Server error 500");
          }
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      setCartType([]);
    }
  }, [dispatch]);
  return { execute, cartType };
};
